import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "loading"]

  showGenerating() {
    this.contentTarget.classList.add('hidden')
    this.loadingTarget.classList.remove('hidden')
    this.loadingTarget.classList.add('flex')
  }
}
